import { Menu, MenuItem, Divider } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fetchLogout, selectUser } from '../../../../store/user/userSlice';
import { logout } from '../../../../store/auth/authSlice';
import { useAppDispatch } from '../../../../../reduxService/hooks';
import { isAuthenticationRequired } from '../../../../utils/authUtils';
import { endpoint } from '../../../../pages';

const UserButton = () => {
    const { t } = useTranslation();

    const user = useSelector(selectUser);
    const dispatch = useAppDispatch();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    // Check if authentication is required for this environment
    const requiresAuth = isAuthenticationRequired();

    const open = Boolean(anchorEl);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleAdminClick = () => {
        setAnchorEl(null);
        window.open(endpoint.adminProducts, '_blank');
    };

    const handleLogout = () => {
        dispatch(fetchLogout());
    };

    const handlePasswordLogout = () => {
        setAnchorEl(null);
        dispatch(logout());
    };

    return user.data ? (
        <>
            <button type="button" className="btn" onClick={handleClick}>
                <i className="fa-regular fa-user" />
                {user.data?.firstName + ' ' + user.data?.lastName}
                <i className="fa-solid fa-angle-down" />
            </button>
            <Menu
                id="basic-menu-save"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {user.data?.isAdmin && (
                    <MenuItem onClick={handleAdminClick}>
                        <i className="fa-solid fa-gear" style={{ marginRight: 8 }} />
                        Admin
                    </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>
                    <i className="fa-solid fa-right-from-bracket" style={{ marginRight: 8 }} />
                    {t('header_user_button_logout')}
                </MenuItem>
                {requiresAuth && (
                    <>
                        <Divider />
                        <MenuItem onClick={handlePasswordLogout} sx={{ color: 'warning.main' }}>
                            {t('header_password_logout', 'Logout (Password Protection)')}
                        </MenuItem>
                    </>
                )}
            </Menu>
        </>
    ) : (
        <></>
    );
};

export default UserButton;
